<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
                    <div class="col-lg-3 ">
                        <label >Serie *</label>
                        <input @change="GuionSerie" type="text" v-model="folio.Serie" class="form-control form-control-sm" placeholder="Nombre" id="Nombre" name="Nombre" />
                        <Cvalidation v-if="this.errorvalidacion.Serie" :Mensaje="'Campo obligatorio'"></Cvalidation>
                    </div>
                    
                    <div class=" col-lg-3">
                        <label >Número Foliado *</label>
                        <!-- <vue-numeric @change="GuionNumero" :minus="false" class="form-control  form-control-sm"  currency="" separator="," :precision="0" v-model="folio.Numero"></vue-numeric> -->
						<input @change="GuionNumero" type="text" v-model="folio.Numero" class="form-control form-control-sm" placeholder="Número" id="Numero" name="Numero" />
						<Cvalidation v-if="this.errorvalidacion.Numero" :Mensaje="'Campo obligatorio'"></Cvalidation>
                    </div>

					<div class="col-lg-3">
                        <label >Año *</label>
                        <vue-numeric @change="GuionNumero" :minus="false" class="form-control  form-control-sm"  currency="" thousand-separator="" :precision="0" v-model="folio.Anio"></vue-numeric>
                        <!-- <Cvalidation v-if="this.errorvalidacion.Numero" :Mensaje="'Campo obligatorio'"></Cvalidation> -->
                    </div>
        
                    <div class="col-lg-3">
                        <label >Tipo *</label>
                        <!-- <select class="form-control form-control-sm"  v-model="folio.Tipo">
                            <option value="">Seleccione una opción</option>
                            <option value="1">Mantenimiento</option>
                            <option value="2">Servicio</option>
                            <option value="3">Proyecto</option>
                        </select> -->
						<treeselect v-model="folio.Tipo" :multiple="true" :options="TipoFolio"></treeselect>
                        <Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="this.errorvalidacion.Tipo[0]"></Cvalidation>
                    </div>
                    <!--fin col-6-->
                </div>
            </template>
        </CLoader>
        <!--Fin body del panel-->
    </div>
</template>
<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
export default {
    name:'Form',
    props:['IdFolio','poBtnSave'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'Numero de Contrato',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            folio:{
                IdFolioContrato:0,
                Serie:"",
                Numero:"",
                Tipo:[],
				Anio:"",
                IdSucursal:""
            },
            urlApi:"foliocontrato/recovery",
            errorvalidacion:[],
			TipoFolio:[
				{
					id:1,label:'Mantenimiento'
				},
				{
					id:2,label:'Servicio'
				},
				{
					id:3,label:'Proyecto'
				},
			]
        }
    },
    components:{
        Cbtnsave,Cvalidation
    },
    methods :
    {
        async Guardar()
        {
            //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
            let formData = new FormData();

			let Numero='';
			if (this.folio.Numero.charAt(this.folio.Numero.length-1)=='-') {
				Numero=this.folio.Numero.slice(0, -1);
			}
			else{
				Numero=this.folio.Numero;
			}
			// console.log(Numero);
			// return false;
            formData.set('IdFolioContrato',this.folio.IdFolioContrato);
            formData.set('Serie',this.folio.Serie);
            formData.set('IdSucursal', this.folio.IdSucursal);
            formData.set('Numero', Numero);
            formData.set('Tipo', this.folio.Tipo);
			formData.set('Anio', this.folio.Anio);

            await this.$http.post(
                'foliocontrato/post',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#ModalForm').modal('hide');
                this.bus.$emit('List');
            }).catch( err => {
				if(err.response.data.message=='Ya existe un folio con el tipo seleccionado.'){
					this.errorvalidacion.Tipo=['Ya existe un folio con el tipo seleccionado'];
					// console.log(this.errorvalidacion);
					this.poBtnSave.disableBtn=false;
                	// this.poBtnSave.toast=2;
					this.$toast.warning(err.response.data.message);
				}
				else{
					this.errorvalidacion=err.response.data.message.errores;
                	this.poBtnSave.disableBtn=false;
                	this.poBtnSave.toast=2;
				}  
            });
        },
        Limpiar()
        {
            this.folio.IdFolioContrato=0,
            this.folio.Numero="",   
            this.folio.IdSucursal="",
            this.folio.Serie="",
            this.folio.Tipo=[];
			this.folio.Anio="";
            this.errorvalidacion=[];
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdFolioContrato: this.folio.IdFolioContrato}
                }
            ).then( (res) => {
                this.folio.IdFolioContrato=res.data.data.folio.IdFolioContrato;
                this.folio.Numero=res.data.data.folio.Numero;
                this.folio.Serie=res.data.data.folio.Serie;
                this.folio.Tipo=res.data.data.folio.Tipo.split(';');
				this.folio.Anio=res.data.data.folio.Anio;
				this.GuionSerie();
				this.GuionNumero();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		GuionSerie(){
			let RefModelo=this.folio.Serie;
			if(RefModelo.charAt(RefModelo.length-1)!='-'){
				this.folio.Serie=this.folio.Serie+'-';
			}
		},
		GuionNumero(){
			if (this.folio.Numero!='') {
				var reg = /^\d+$/;
				let RefModelo=this.folio.Numero.toString();
				let Entero='';
				if (RefModelo.charAt(RefModelo.length-1)=='-') {
					Entero=RefModelo.slice(0, -1);
				}
				else{
					Entero=RefModelo;
				}
				if (!reg.test(Entero)) {
					this.folio.Numero=0;
				}
				else{
					if(RefModelo.charAt(RefModelo.length-1)!='-' && this.folio.Anio!=''){
						this.folio.Numero=RefModelo+'-';
					}
				}	
			}
		},
    },
    created() {       
        this.bus.$off('Nuevo');

        //Este es para modal
        this.bus.$on('Nuevo',(data,Id)=> 
        {
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
            this.bus.$off('Save');
            this.bus.$on('Save',()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            if (Id>0)
            {
                this.folio.IdFolioContrato=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
        });
        if (this.Id!=undefined)
        {
            this.folio.IdFolioContrato=this.Id;
            this.get_one();
        }
    }
}
</script>
